import { JustifyContent, SizeType } from '@payflip/types/product-builder';
import { AnchorHTMLAttributes, forwardRef, MouseEvent } from 'react';
import { Link, LinkProps } from 'react-router';
import { IconWrapper } from '../button/styled';
import { Icon, IconName } from '../icons';
import { StyledLinkButton } from './styled';

export type LinkButtonVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'alert';

export type LinkButtonProps = React.PropsWithChildren<
  AnchorHTMLAttributes<HTMLAnchorElement> &
    Omit<LinkProps, 'to'> & {
      variant?: LinkButtonVariant;
      size?: SizeType;
      icon?: IconName | null;
      iconPosition?: 'left' | 'right';
      disabled?: boolean;
      fullWidth?: boolean;
      contentLayout?: JustifyContent;
      internal?: boolean;
      to?: string;
      openInNewTab?: boolean;
    }
>;

export const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>(
  (
    {
      children,
      variant = 'primary',
      size = SizeType.Medium,
      disabled = false,
      icon,
      iconPosition = 'right',
      fullWidth = false,
      contentLayout = 'stretch',
      internal = false,
      openInNewTab,
      ...props
    },
    ref
  ): JSX.Element => {
    return (
      <StyledLinkButton
        ref={ref}
        as={internal ? Link : 'a'}
        disabled={disabled}
        variant={variant}
        size={size}
        onClick={(e: MouseEvent<HTMLAnchorElement>): void => {
          if (disabled) {
            e.preventDefault();
          }
        }}
        $fullWidth={fullWidth}
        $contentLayout={contentLayout}
        target={
          (typeof openInNewTab === 'undefined' && !internal) ||
          openInNewTab === true
            ? '_blank'
            : undefined
        }
        {...props}
      >
        {icon && (
          <IconWrapper
            position={iconPosition}
            noMargin={
              typeof children === 'undefined' ||
              children === null ||
              children === ''
            }
          >
            <Icon name={icon} />
          </IconWrapper>
        )}
        <span style={{ order: iconPosition === 'right' ? 1 : 2 }}>
          {children}
        </span>
      </StyledLinkButton>
    );
  }
);
